// extracted by mini-css-extract-plugin
export var alignCenter = "_9j-d";
export var bannerShown = "_9j-6";
export var buttonContent = "_9j-0";
export var cardList = "_9j-1";
export var centerContent = "_9j-2";
export var chevron = "_9j-3";
export var closePanelButton = "_9j-k";
export var conversationContextContainer = "_9j-l";
export var conversationDetailContainer = "_9j-4";
export var detailWrapper = "_9j-7";
export var dropdownButton = "_9j-e";
export var dropdownTitle = "_9j-9";
export var fullHeight = "_9j-5";
export var hidden = "_9j-a";
export var icon = "_9j-b";
export var mergeSuggestionWrapper = "_9j-m";
export var panel = "_9j-i";
export var portalButtonsWrapper = "_9j-c";
export var right = "_9j-j";
export var tableSummaryContainer = "_9j-8";
export var tableSummaryHeader = "_9j-g";
export var threeDotsButton = "_9j-f";
export var wide = "_9j-h";